import isString from 'lodash/isString';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import defaultTo from 'lodash/defaultTo';
import trim from 'lodash/trim';

export const DATA_NOT_AVAILABLE = '';
export const NO_ATTRIBUTE = '[Нет аттрибута]';

export const isBlank = (data?: string | object | any[]) =>
  isString(data) ? isEmpty(trim(data)) : !data;

export const isPresent = (data?: string | object | any[]) => !isBlank(data);

export const mayBe = (val?: string, suffix: string = '') =>
  isPresent(val) ? `${val}${suffix}` : DATA_NOT_AVAILABLE;

export const yesNo = (condition: boolean) => (condition ? 'Да' : 'Нет');

export const hasDataInArray = (data: any[]) => isArray(data) && data.length > 0;
export const isNotEmpty = (data: any) => !isEmpty(data);

export { isArray, isString, isEmpty, defaultTo };
